import { render, staticRenderFns } from "./RegisteredCamsTable.vue?vue&type=template&id=760a9a72&"
import script from "./RegisteredCamsTable.vue?vue&type=script&lang=js&"
export * from "./RegisteredCamsTable.vue?vue&type=script&lang=js&"
import style0 from "./RegisteredCamsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDataTable,VImg,VSpacer})
